export const windowSizeBreakpoints = {
  phone: 500,
  small: 700,
  medium: 900,
  mediumBig: 1120,
  big: 1330,
  laptop: 1650, // Utilisé exclusiment pour les détails d'une salle pour l'instant
}
